export default __webpack_public_path__ + "static/media/swlogo.3bf2a05e.svg";